import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mx-auto my-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.isShow,
    persistent: "",
    "max-width": "500",
    "min-width": "500"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pt-7 text-center border-radius-8" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "pa-0 justify-center font-weight-bold font-color-5" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("dialogs.unexpectedError.title")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "pa-0 mt-5 font-size-16 text-gray-40" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("dialogs.unexpectedError.description")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "pa-0" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  color: "primary",
                  class: "btn-common",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShow = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("buttons.close")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}